import { store } from '@/store'

export default {

       async sortBiomarkersVariantTypeMainTypes(response) {

            //alert(JSON.stringify(Object.keys(response)))
            store.dispatch("setGenes", response.genes)
            store.dispatch("setFusions", response.fusions)
            store.dispatch("setInDels", response.indels)
            store.dispatch("setSNVs",response.snvs)
            store.dispatch("setUnidentified",response.unidentified)
            //alert(JSON.stringify(store.getters.snvs))
            //alert(JSON.stringify(store.getters.indels))
       },
       async sortBiomarkersVariantType(data_dir="tmp") {
            let store_variants = store.getters.getVariants
            let store_snvs = store.getters.snvs
            //alert("sort types: snvs "+JSON.stringify(store.getters.snvs))
            //let store_fusions = store.getters.fusions
            let store_unidentified = store.getters.unidentified

            let call_setsnv = ""
            let call_setins = ''
            let call_setdel = ''
            let call_setcnvs = ''
            //let call_setfusions = ''
            let call_setunidentified = ''
            let call_setvariants = 'setVariants'

            if (data_dir.localeCompare("tmp") == 0) {
                call_setsnv = 'setSNVs'
                call_setins = 'setIns'
                call_setdel = 'setDels'
                call_setcnvs = 'setCNVs'
                //call_setfusions = 'setFusions'
                call_setunidentified = 'setUnidentified'
                call_setvariants = 'setVariants'
            } else if (data_dir.localeCompare("loc") == 0) {
                call_setsnv = 'setIdSNVs'
                call_setins = 'setIdIns'
                call_setdel = 'setIdDels'
                call_setcnvs = 'setIdCNVs'
                //call_setfusions = 'setIdFusions'
                call_setunidentified = 'setIdUnidentified'
                call_setvariants = 'setIdVariants'
            }

            //store.dispatch(call_setvariants, {})
            /* store.dispatch(call_setsnv,{})
            store.dispatch(call_setins,{})
            store.dispatch(call_setdel,{})
            store.dispatch(call_setcnvs,{}) */
            //store.dispatch(call_setfusions,{})
            store.dispatch(call_setunidentified,{})

            if (data_dir.localeCompare("tmp") == 0) {
                store_variants = store.getters.getVariants
                store_snvs = store.getters.snvs
                //store_fusions = store.getters.fusions
                store_unidentified = store.getters.unidentified
            } else if (data_dir.localeCompare("loc") == 0) {
                store_variants = store.getters.id_variants
                store_snvs = store.getters.id_snvs
                //store_fusions = store.getters.id_fusions
                store_unidentified = store.getters.id_unidentified
            }

            for (let qid in store_variants) {
                if ("variant_data" in store_variants[qid]) {
                    if ("type" in store_variants[qid]["variant_data"]) {
                        let type = store_variants[qid]["variant_data"]["type"]
                        //alert(type)

                            if ((type=="snv") || (type=="SNV") || (type=="Missense SNV")
                            || (type=="Nonsense SNV")|| (type=="Silent SNV") || (type=="Unknown substitution")
                            ) {
                                let snvs = store_snvs
                                if (snvs == null) {
                                    snvs = {}
                                }
                                snvs[qid] = store_variants[qid]
                                store.dispatch(call_setsnv,snvs)
                            } else if (type=="insertion") {
                                let indes = store_indels
                                if (indels == null) {
                                    indels = {}
                                }
                                indels[qid] = store_indels[qid]
                                store.dispatch(call_setInDels,indels)
                            } else if (type=="deletion") {
                                let indes = store_indels
                                if (indels == null) {
                                    indels = {}
                                }
                                indels[qid] = store_indels[qid]
                                store.dispatch(call_setInDels,indels)
                            } else if (type=="cnv") {
                            /*} else if (type=="fusion") {
                                let fusions = store_fusions
                                if (fusions == null) {
                                    fusions = {}
                                }
                                fusions[qid] = store_variants[qid]
                                store.dispatch(call_setfusions, fusions)*/
                            } else if (type=="gene") {
                            } else if ((type=="unidentified") || (type=="")) {
                                let unidentified = store_unidentified
                                if (unidentified == null) {
                                    unidentified = {}
                                }
                                unidentified[qid] = store_variants[qid]
                                //store.dispatch(call_setunidentified,unidentified)
                                //alert(JSON.stringify(store.getters.unidentified))
                            }
                        }
                }
            }
       }

}
